import React, { useState, useEffect, useRef } from "react";

import { API_URL } from "../helpers";

export default function Total() {
	const [alert, setAlert] = useState({ type: "working", text: "" });
	const [details, setDetails] = useState({});

	const initRef = useRef(false);

	useEffect(() => {
		if (initRef.current) return;
		initRef.current = true;

		init();
	});

	const init = async () => {
		const url = new URL(`${API_URL}/toolsTotalInit`);
		const params = {};
		url.search = new URLSearchParams(params);

		try {
			const response = await fetch(url, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setDetails({ ...json });
				setAlert({});
			} else {
				setAlert({
					type: json.resp === 2 ? "notice" : "error",
					text: json.text,
				});
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<>
			{alert.type ? (
				<div />
			) : (
				<h3
					style={{ marginTop: "20px", marginBottom: "0", borderBottom: "none" }}
				>{`GRAND TOTAL RAISED TO DATE: ${details.total}`}</h3>
			)}
		</>
	);
}
